import { Pipe, PipeTransform } from '@angular/core';
import linkifyHtml from 'src/shared/util/linkify';

@Pipe({
    name: 'parseText',
    standalone: false
})
export class ParseTextPipe implements PipeTransform {
  transform(value: string | number, checkLineBreaks: boolean, linkify: boolean): string {
    // Only skip missing values: a count of 0 must still render
    if (value === null || value === undefined) {
      return '';
    }
    let transformedText = String(value);

    if(checkLineBreaks) {
      transformedText = transformedText.replace(/(↵|\n|↵)/g, '<br/>');
    }

    if(linkify) {
      transformedText = linkifyHtml(transformedText, {target: '_blank'});
    }

    return transformedText;
  }
}
